/**
 * Resolves the display image for a lookbook entry (a VTO result).
 *
 * Mirrors LookbookEntryCard's own resolution order so share previews show the
 * same picture the card does.
 *
 * @param {object} entry
 * @returns {string|null}
 */
export const getEntryPreviewUrl = (entry) => {
  if (!entry) return null;
  if (Array.isArray(entry.allImages) && entry.allImages.length > 0) return entry.allImages[0];
  if (entry.useRemovedImage !== false && entry.removedBgImage?.url) return entry.removedBgImage.url;
  return (
    (Array.isArray(entry.resultImage) ? entry.resultImage[0]?.url : entry.resultImage?.url) ||
    entry.imageUrl ||
    entry.previewImage ||
    null
  );
};

export default getEntryPreviewUrl;
